const firebaseConfig = {
  apiKey: "AIzaSyBsXlf7reWKbPznpYtHws_Er7Ni4PUM80c",
  authDomain: "d-express-e9155.firebaseapp.com",
  projectId: "d-express-e9155",
  storageBucket: "d-express-e9155.appspot.com",
  messagingSenderId: "951411061892",
  appId: "1:951411061892:web:18b0a5b902c8f38b547ed1"
};
export default firebaseConfig;
